import { Field } from "redux-form/immutable";

import {
  Box,
  Button,
  Column,
  Columns,
  Stack,
  styledWithConfig
} from "@seneca/senekit";

import { FormTextInput } from "features/forms/components/FormTextInput";
import ErrorMessage from "features/sign-up/components/ErrorMessage";
import SignUpWithProgressBarWrapper from "features/sign-up/components/SignUpWithProgressBarWrapper";

import MarketingEmailsCheckbox from "../components/MarketingEmailsCheckbox/MarketingEmailsCheckbox";
import useShowMarketingEmailsCheckboxByVariant from "../components/MarketingEmailsCheckbox/useShowMarketingEmailsCheckboxByVariant";

type Props = {
  handleSubmit: () => void;
  submitting: boolean;
  error: string;
  pageNumber: number;
  totalNumberOfPages: number;
  loading: boolean;
};

const Form = styledWithConfig("form");

export default function SignUpFormUserDetails({
  handleSubmit,
  submitting,
  error,
  pageNumber,
  totalNumberOfPages,
  loading
}: Props) {
  const showMarketingEmailsCheckbox = useShowMarketingEmailsCheckboxByVariant();

  return (
    <SignUpWithProgressBarWrapper
      header="Tell us about yourself"
      pageNumber={pageNumber}
      totalNumberOfPages={totalNumberOfPages}
    >
      <Form onSubmit={handleSubmit} width="100%">
        <Box
          display="flex"
          justifyContent="space-between"
          flexDirection={"column"}
          flexWrap="wrap"
          marginTop={"xlarge"}
        >
          <Stack space="xlarge">
            <Field
              name="givenName"
              label="First name"
              component={FormTextInput}
              type="text"
              placeholder="Enter your first name"
            />

            <Field
              name="familyName"
              label="Last name"
              component={FormTextInput}
              type="text"
              placeholder="Enter your last name"
            />

            {showMarketingEmailsCheckbox && (
              <Field
                name="isSubscribedToMarketingEmails"
                component={MarketingEmailsCheckboxField}
              />
            )}
          </Stack>
        </Box>

        <ErrorMessage>{error}</ErrorMessage>
        {/* @ts-ignore fix-in-senekit */}
        <Columns
          collapseBelow="tablet"
          reverseOnCollapse
          alignY="baseline"
          alignX="center"
          space="xlarge"
        >
          <Column alignX={["center", "flex-end"]}>
            <Button
              width={["100%", "170px"]}
              onClick={() => {}}
              loading={submitting || loading}
              disabled={submitting || loading}
            >
              {pageNumber === totalNumberOfPages
                ? "Finish sign up"
                : "Next step"}
            </Button>
          </Column>
        </Columns>
      </Form>
    </SignUpWithProgressBarWrapper>
  );
}

type CheckboxFieldInput = {
  input: { name: string; value: boolean; onChange: () => void };
};

function MarketingEmailsCheckboxField(props: CheckboxFieldInput) {
  const {
    input: { name, value, onChange }
  } = props;
  return (
    <MarketingEmailsCheckbox name={name} checked={value} onChange={onChange} />
  );
}
